export default {
  "content": "<path d=\"M13 3h-2v9h2V3z\" fill=\"#7B61FF\"/><path d=\"M5.135 10.634A7 7 0 017.05 7.05L5.636 5.636a9 9 0 1012.728 0L16.95 7.05a7 7 0 11-11.815 3.584z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};